var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"container px-4 mx-auto"},[_c('a',{staticClass:"block text-body uppercase cursor-pointer mb-6",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(_vm._s(_vm.back))])])])}
var staticRenderFns = []

export { render, staticRenderFns }